import { required, minLength } from '@vuelidate/validators';

// PATCH ZERA (16/07/2026): o validador do cliente so barrava ESPACO, enquanto o servidor valida com
// UNICODE_CHARACTER_NUMBER_HYPHEN_UNDERSCORE (lib/regex_helper.rb) e rejeita ponto, barra, '!',
// parenteses e titulo comecando com _ ou -. Nomes tipo 'a1.pj' ou '2.via' passavam no cliente, o
// botao ficava habilitado, e o servidor devolvia 422 - que o EditLabel engolia num "tente novamente"
// generico (o atendente nunca descobria o motivo). Agora o cliente barra na hora e mostra o
// VALID_ERROR que ja existe traduzido em pt_BR.
export const validLabelCharacters = (str = '') =>
  !!str && /^[\p{L}\p{N}]+[\p{L}\p{N}_-]+$/u.test(str);

export const getLabelTitleErrorMessage = validation => {
  let errorMessage = '';
  if (!validation.title.$error) {
    errorMessage = '';
  } else if (!validation.title.required) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.REQUIRED_ERROR';
  } else if (!validation.title.minLength) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.MINIMUM_LENGTH_ERROR';
  } else if (!validation.title.validLabelCharacters) {
    errorMessage = 'LABEL_MGMT.FORM.NAME.VALID_ERROR';
  }
  return errorMessage;
};

export default {
  title: {
    required,
    minLength: minLength(2),
    validLabelCharacters,
  },
  description: {},
  color: {
    required,
  },
  showOnSidebar: {},
};
